// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"Q6gTb___UpdateSearchDropdown-module__dropdownMenu"};